var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"calendar","fluid":""}},[_c('b-card',[_c('full-calendar',{ref:"refCalendar",staticClass:"full-calendar",attrs:{"options":_vm.calendarOptions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }